// extracted by mini-css-extract-plugin
export var languageSelector = "language-selector-module--language-selector--1ILk5";
export var languageSelector__flag = "language-selector-module--language-selector__flag--3TwaI";
export var languageSelector__switch = "language-selector-module--language-selector__switch--3wRsD";